import { Component, OnInit, ViewChild, inject } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { selectorAuth } from "@app/core";
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from "@angular/forms";
import { STEPPER_GLOBAL_OPTIONS } from "@angular/cdk/stepper";
import { TeamStore } from "@app/services/store/team-store";
import { Team } from "@app/models/rest/team";
import { DomSanitizer } from "@angular/platform-browser";
import { UserService } from "@app/services/rest/user.service";
import { Router } from "@angular/router";
import { GridComponent } from "@app/view/shared/base-pages/base-data-table-page/grid.component";
import { MatCard, MatCardContent } from "@angular/material/card";
import {
  MatStep,
  MatStepLabel,
  MatStepper,
  MatStepperNext,
  MatStepperPrevious
} from "@angular/material/stepper";
import { MatFormField } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatButton } from "@angular/material/button";
import { GridComponent as GridComponent_1 } from "../shared/base-pages/base-data-table-page/grid.component";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-registration",
  templateUrl: "./registration.component.html",
  styleUrls: ["./registration.component.css"],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { showError: true }
    }
  ],
  imports: [
    MatCard,
    MatCardContent,
    MatStepper,
    MatStep,
    MatStepLabel,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatInput,
    MatButton,
    MatStepperNext,
    GridComponent_1,
    MatStepperPrevious,
    MatProgressSpinner,
    TranslatePipe
  ]
})
export class RegistrationComponent implements OnInit {
  private store = inject<Store<any>>(Store);
  private _formBuilder = inject(UntypedFormBuilder);
  private teamService = inject(TeamStore);
  private userService = inject(UserService);
  private router = inject(Router);
  private _sanitizer = inject(DomSanitizer);

  firstFormGroup: UntypedFormGroup = new UntypedFormGroup({});
  secondFormGroup: UntypedFormGroup = new UntypedFormGroup({});
  thirdFormGroup: UntypedFormGroup = new UntypedFormGroup({});
  public tokenName: string;
  public teams: Team[];
  public processingRegistration = false;
  public registrationComplete = false;
  public registrationError = false;
  public controlTeamMapping: { controlId: string; team: Team }[] = [];
  errorTime: Date;
  errorMessage: string;
  columns: object[] = [
    //
    // { field: 'selected', type: 'check', width: 50},
    { field: "id", hidden: true },
    { field: "team", text: "Select Teams", flex: 1 }
  ];
  rows: object[] = [];
  @ViewChild(GridComponent, { static: false }) grid: GridComponent;
  selectionMode = {
    checkbox: true,
    rowCheckboxSelection: true,
    multiSelect: true,
    showCheckAll: true,
    row: true
  };
  private controlConfig = {};

  constructor() {
    this.store.pipe(select(selectorAuth)).subscribe((authState) => {
      this.tokenName = authState.fullName;
    });
  }

  ngOnInit() {
    this.userService.getPlanner().then((value) => {
      if (value) {
        this.processingRegistration = true;
        this.registrationComplete = true;
      }
    });
    this.firstFormGroup = this._formBuilder.group({
      displayName: [this.tokenName, Validators.required]
    });

    this.teamService.loadAll().then((teams) => {
      console.log("team-list loaded");
      this.teams = teams.resources;

      teams.resources.forEach((value) => {
        this.controlConfig["team-" + value.id] = [false, Validators.required];
        this.rows.push({
          team: value.name,
          id: value.id,
          selected: false
        });
      });
      this.secondFormGroup = this._formBuilder.group(this.controlConfig);
      console.log(this.secondFormGroup);
    });

    this.thirdFormGroup = this._formBuilder.group({});
  }

  getTeamFromControl(controlName: string) {
    return this.controlTeamMapping.find((x) => x.controlId === controlName)
      .team;
  }

  finaliseRegistration() {
    this.processingRegistration = true;
    let teamList: number[] = [];
    if (this.grid.selectedRecords) {
      for (let i = 0; i < this.grid.selectedRecords.length; i++) {
        // @ts-ignore
        teamList.push(this.grid.selectedRecords[i].data.id);
      }
    }

    console.log(
      "finalising registration with ",
      this.firstFormGroup.controls["displayName"].value,
      teamList
    );
    this.userService
      .register(this.firstFormGroup.controls["displayName"].value, teamList)
      .then((value) => {
        console.log("register complete, value: " + value);
        this.registrationError = !value;
        this.registrationComplete = true;
        if (this.registrationError) {
          this.errorTime = new Date();
          this.errorMessage =
            "The server did not indicate a successful registration.";
        }
      })
      .catch((reason) => {
        console.log("registration error");
        this.registrationError = true;
        this.registrationComplete = true;
        this.errorTime = new Date();
        this.errorMessage = JSON.stringify(reason);
      });
  }

  reloadWindow() {
    this.router.navigate([""]).finally(() => {
      window.location.reload();
    });
  }
}
